<template>
  <div class="col-12 pt-2">
    <p class="fw-bold body-strong">
      {{ Title }}
    </p>
    <div class="d-flex flex-column gap-3">
      <RSEcard
        v-if="isCriteriaFloconVert"
        :title="greenSnowFlakePopupData.title"
        :description="greenSnowFlakePopupData.description"
        :icon="greenSnowFlakePopupData.icon"
        linkKey="green-snowflake"
      />
      <RSEcard
        v-if="isCriteriaCleVerte"
        :title="greenKeyPopupData.title"
        :description="greenKeyPopupData.description"
        :icon="greenKeyPopupData.icon"
        linkKey="green-key"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import greenSnowFlake from '@/images/green-snowflake.png';
import greenKey from '@/images/green-key.png';
import greenKeyFR from '@/images/green-key-fr.png';

// Enums
import { Locales } from '@/enums/locales';

// Components
import RSEcard from './RSEcard.vue';

// Composables
import useLocale from '@/vue/composables/useLocale';

const locale = ref<string>(useLocale());

// Props
interface IRSEblock {
  isCriteriaFloconVert: boolean;
  isCriteriaCleVerte: boolean;
}
const props = defineProps<IRSEblock>();

// Refs
const content = ref<{ [key: string]: string }>(window.content);

// Computed values
const greenKeyLogo = computed<string>(() => {
  const localeMap: Record<string, string> = {
    [Locales.FR]: greenKeyFR,
    [Locales.UK]: greenKey,
    [Locales.NL]: greenKey,
  };
  return localeMap[locale.value] || greenKeyFR;
});

// Compute the eco-responsible commitment labels title based on the criteria
const Title = computed<string>(() => {
  if (props.isCriteriaFloconVert && props.isCriteriaCleVerte) {
    return content.value.eco_responsible_commitment_labels_title_if_both;
  } else if (props.isCriteriaCleVerte) {
    return content.value.eco_responsible_commitment_labels_title_if_cleverte;
  } else if (props.isCriteriaFloconVert) {
    return content.value.eco_responsible_commitment_labels_title_if_flaconvert;
  }
  return '';
});


// Data for cards
const greenSnowFlakePopupData = {
  title: content.value.eco_responsible_commitments_green_snowflake_label,
  description: content.value.eco_responsible_commitments_green_snowflake_text,
  icon: greenSnowFlake,
};

const greenKeyPopupData = {
  title: content.value.eco_responsible_commitments_green_key_label,
  description: content.value.eco_responsible_commitments_green_key_text,
  icon: greenKeyLogo.value,
};
</script>